<template>
  <div style="width: 1800px;">
    <canvas
      v-show="lineChartShow"
      ref="trendCanvas"
      :width="canvas.width"
      :height="canvas.height"
      class="trend-canvas"
    ></canvas>
    <table ref="trendTable" class="chart-table" style='border-collapse:collapse'>
      <thead ref="Head">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <template v-if="currPlay === 'gj'">
          <th colspan="12" class="border-right border-bottom">冠军分布</th>
          <th colspan="6" class="border-right border-bottom">冠军</th>
          <th colspan="6" class="border-right border-bottom">冠军</th>
          <th colspan="6" class="border-right border-bottom">冠军</th>
          <th colspan="9" class="border-right border-bottom">冠军</th>
          </template>
          <template v-if="currPlay === 'yj'">
          <th colspan="12" class="border-right border-bottom">亚军分布</th>
          <th colspan="6" class="border-right border-bottom">亚军</th>
          <th colspan="6" class="border-right border-bottom">亚军</th>
          <th colspan="6" class="border-right border-bottom">亚军</th>
          <th colspan="9" class="border-right border-bottom">亚军</th>
          </template>
          <template v-if="currPlay === 'jj'">
          <th colspan="12" class="border-right border-bottom">季军分布</th>
          <th colspan="6" class="border-right border-bottom">季军</th>
          <th colspan="6" class="border-right border-bottom">季军</th>
          <th colspan="6" class="border-right border-bottom">季军</th>
          <th colspan="9" class="border-right border-bottom">季军</th>
          </template>
          <template v-if="currPlay === 'dsm'">
          <th colspan="12" class="border-right border-bottom">第四名分布</th>
          <th colspan="6" class="border-right border-bottom">第四名</th>
          <th colspan="6" class="border-right border-bottom">第四名</th>
          <th colspan="6" class="border-right border-bottom">第四名</th>
          <th colspan="9" class="border-right border-bottom">第四名</th>
          </template>
          <template v-if="currPlay === 'dwm'">
          <th colspan="12" class="border-right border-bottom">第五名分布</th>
          <th colspan="6" class="border-right border-bottom">第五名</th>
          <th colspan="6" class="border-right border-bottom">第五名</th>
          <th colspan="6" class="border-right border-bottom">第五名</th>
          <th colspan="9" class="border-right border-bottom">第五名</th>
          </template>
          <template v-if="currPlay === 'dlm'">
          <th colspan="12" class="border-right border-bottom">第六名分布</th>
          <th colspan="6" class="border-right border-bottom">第六名</th>
          <th colspan="6" class="border-right border-bottom">第六名</th>
          <th colspan="6" class="border-right border-bottom">第六名</th>
          <th colspan="9" class="border-right border-bottom">第六名</th>
          </template>
          <template v-if="currPlay === 'dqm'">
          <th colspan="12" class="border-right border-bottom">第七名分布</th>
          <th colspan="6" class="border-right border-bottom">第七名</th>
          <th colspan="6" class="border-right border-bottom">第七名</th>
          <th colspan="6" class="border-right border-bottom">第七名</th>
          <th colspan="9" class="border-right border-bottom">第七名</th>
          </template>
          <template v-if="currPlay === 'dbm'">
          <th colspan="12" class="border-right border-bottom">第八名分布</th>
          <th colspan="6" class="border-right border-bottom">第八名</th>
          <th colspan="6" class="border-right border-bottom">第八名</th>
          <th colspan="6" class="border-right border-bottom">第八名</th>
          <th colspan="9" class="border-right border-bottom">第八名</th>
          </template>
          <template v-if="currPlay === 'djm'">
          <th colspan="12" class="border-right border-bottom">第九名分布</th>
          <th colspan="6" class="border-right border-bottom">第九名</th>
          <th colspan="6" class="border-right border-bottom">第九名</th>
          <th colspan="6" class="border-right border-bottom">第九名</th>
          <th colspan="9" class="border-right border-bottom">第九名</th>
          </template>
          <template v-if="currPlay === 'dtm'">
          <th colspan="12" class="border-right border-bottom">第十名分布</th>
          <th colspan="6" class="border-right border-bottom">第十名</th>
          <th colspan="6" class="border-right border-bottom">第十名</th>
          <th colspan="6" class="border-right border-bottom">第十名</th>
          <th colspan="9" class="border-right border-bottom">第十名</th>
          </template>
        </tr>
        <tr class="title-number">
          <th class="ball-none border-bottom-header"></th>
          <th class="border-bottom-header" v-for="(num, thnindex) in lotteryNumbHead" :key="thnindex + 'num'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th class="ball-none border-bottom-header border-right"></th>
          <template v-for="(numStatus, nsindex) in lotteryNumStatusHead">
          <th class="ball-none border-bottom-header" :key="nsindex + 'left'"></th>
          <th class="border-bottom-header" :key="nsindex + 'center'">
            <i class="ball-noraml">{{ numStatus }}</i>
          </th>
          <th :key="nsindex + 'right'" class="ball-none border-bottom-header border-right"></th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 号码走势 -->
          <template v-if="currPlay === 'gj'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[0][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num.toString() }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'yj'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[1][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'jj'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[2][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'dsm'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[3][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'dwm'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[4][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'dlm'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[5][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'dqm'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[6][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'dbm'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[7][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'djm'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[8][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <template v-if="currPlay === 'dtm'">
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:63.2px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'num'" v-for="(num, nindex) in openNumSperateTrendList[9][index]">
              <i class="ball-noraml openNo padd3" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
            <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          </template>
          <!-- 奇偶 -->
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="odd[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ odd[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="even[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ even[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <!-- 大小 -->
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="big[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ big[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="small[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ small[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <!-- 质合 -->
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="primeNumber[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ primeNumber[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="compositeNumber[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ compositeNumber[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <!-- 012 -->
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="zero[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ zero[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="one[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ one[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td colspan="3" class="border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">
            <i class="ball-noraml duizi" v-if="two[index] == 'A'"></i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ two[index] }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
        </tr>
      </tbody>
      <tfoot v-show="statisticalShow" v-if="lotteryTrendList&&lotteryTrendList.length > 0">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-if="currPlay === 'gj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[0].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td>
          </template>
          <template v-if="currPlay === 'yj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[1].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'jj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[2].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dsm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[3].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dwm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[4].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dlm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[5].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dqm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[6].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dbm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[7].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'djm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[8].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dtm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(count, sindex) in openNumSperateStatisticaList[9].countArr">
              <i class="ball-noraml">{{ count }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( odd ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( even ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( big ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( small ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( primeNumber ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( compositeNumber ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( zero ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( one ,'A') }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ counts( two ,'A') }}</i>
          </td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-if="currPlay === 'gj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'count'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[0].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td>
          </template>
          <template v-if="currPlay === 'yj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[1].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'jj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[2].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dsm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[3].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dwm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[4].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dlm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[5].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dqm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[6].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dbm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[7].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'djm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[8].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dtm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'averageMiss'" v-for="(averageMiss, sindex) in openNumSperateStatisticaList[9].averageMissArr">
              <i class="ball-noraml">{{ averageMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(odd) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(even) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(big) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(small) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(primeNumber) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(compositeNumber) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(zero) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(one) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ averageMissArrs(two) }}</i>
          </td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-if="currPlay === 'gj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[0].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td>
          </template>
          <template v-if="currPlay === 'yj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[1].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'jj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[2].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dsm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[3].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dwm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[4].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dlm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[5].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dqm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[6].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dbm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[7].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'djm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[8].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dtm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxMiss'" v-for="(maxMiss, sindex) in openNumSperateStatisticaList[9].maxMissArr">
              <i class="ball-noraml">{{ maxMiss }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(odd) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(even) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(big) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(small) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(primeNumber) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(compositeNumber) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(zero) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(one) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxMissArrs(two) }}</i>
          </td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <template v-if="currPlay === 'gj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[0].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td>
          </template>
          <template v-if="currPlay === 'yj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[1].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'jj'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[2].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dsm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[3].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dwm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[4].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dlm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[5].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dqm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[6].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dbm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[7].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'djm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[8].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <template v-if="currPlay === 'dtm'">
            <td class="ball-none border-bottom"></td>
            <td class="border-bottom" :key="sindex + 'maxContinuity'" v-for="(maxContinuity, sindex) in openNumSperateStatisticaList[9].maxContinuity">
              <i class="ball-noraml">{{ maxContinuity }}</i>
            </td>
            <td class="ball-none border-right border-bottom"></td> 
          </template>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(odd) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(even) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(big) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(small) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(primeNumber) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(compositeNumber) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(zero) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(one) }}</i>
          </td>
          <td colspan="3" class="border-right border-bottom">
            <i class="ball-noraml">{{ maxContinuitys(two) }}</i>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
export default {
  name: 'Pk10Chart',
  mixins: [mix],
  props: {
    currPlay: {
      type: [String],
      default: 'gj'
    }
  },
  computed: {
    // 奇数
    odd() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 !== 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      return arr.reverse()
    },
    // 偶数
    even() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) % 2 === 0) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      return arr.reverse()
    },
    // 大
    big() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) > 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      return arr.reverse()
    },
    // 小
    small() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if(Number(num) <= 5) {
            arr[index] = 'A'
            i = 1
          }
        })
      } 
      return arr.reverse()
    },
    // 质数
    primeNumber() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if([1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      return arr.reverse()
    },
    // 合数
    compositeNumber() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if(![1, 2, 3, 5, 7].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      return arr.reverse()
    },
    // 012
    zero() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if([3, 6, 9].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      return arr.reverse()
    },
    one() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[9]).forEach((num, index) => {
          arr.push(i++)
          if([1, 4, 7, 10].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      return arr.reverse()
    },
    two() {
      let arr = []
      let i = 1
      if(this.currPlay === 'gj') {
        this.reverseArray(this.openNumSperateArr[0]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'yj') {
        this.reverseArray(this.openNumSperateArr[1]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'jj') {
        this.reverseArray(this.openNumSperateArr[2]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dsm') {
        this.reverseArray(this.openNumSperateArr[3]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dwm') {
        this.reverseArray(this.openNumSperateArr[4]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dlm') {
        this.reverseArray(this.openNumSperateArr[5]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dqm') {
        this.reverseArray(this.openNumSperateArr[6]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dbm') {
        this.reverseArray(this.openNumSperateArr[7]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'djm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      if(this.currPlay === 'dtm') {
        this.reverseArray(this.openNumSperateArr[8]).forEach((num, index) => {
          arr.push(i++)
          if([2, 5, 8].includes(Number(num))) {
            arr[index] = 'A'
            i = 1
          }
        })
      }
      return arr.reverse()
    }
  },
  mounted() {
    console.log('创建了')
    this.$nextTick((e) => {
      console.log('创建了', this.$refs.trendTable)
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawCanvas();
        }, 0);
      });
    });
  },
  updated() {
    this.$nextTick((e) => {
      console.log('更新了', this.$refs.trendTable)
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawCanvas();
        }, 0);
      });
    });
  },
  methods: {
    reverseArray(arr) {
      const originArr = JSON.parse(JSON.stringify(arr))
      return originArr.reverse()
    },
    drawCanvas() {
      let coordinateList
      switch(this.currPlay) {
        case 'gj':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[0]);
          break;
        case 'yj':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[1]);
          break;
        case 'jj':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[2]);
          break;
        case 'dsm':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[3]);
          break;
        case 'dwm':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[4]);
          break;
        case 'dlm':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[5]);
          break;
        case 'dqm':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[6]);
          break;
        case 'dbm':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[7]);
          break;
        case 'djm':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[8]);
          break;
        case 'dtm':
          coordinateList = this.getChartCoordinate(this.openNumSperateTrendList[9]);
          break;
        default:
          break;
      }
      if(!coordinateList) {
        return;
      }
      const ctx = this.$refs.trendCanvas.getContext("2d");
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ctx.beginPath();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#f53f00";
      for (let i = 0, len = coordinateList.length; i + 1 < len; i++) {
        ctx.moveTo(coordinateList[i][0], coordinateList[i][1]);
        ctx.lineTo(coordinateList[i + 1][0], coordinateList[i + 1][1]);
      }
      ctx.stroke();
    },
    getChartCoordinate(Coordinate) {
      if (!this.$refs.drawnumbHead) return [];
      if(!Coordinate) return [];
      let len = Coordinate.length;
      if (len == 0) return [];
      let chartCoordinate = [];
      //获取坐标系
      //先获取表格左边不需要折线部分的宽度
      let dwidth = this.$refs.drawnumbHead.offsetWidth;
      let pwidth = this.$refs.periodsHead.offsetWidth;
      let topCountWidth = this.$refs.Head.offsetHeight; // 上面总高度
      let leftCountWidth = dwidth + pwidth ; // 左边总宽度
      //每个数据表格td宽度 表格td高度
      if(!document.getElementById("smallRect")) {
        return;
      }
      const tdWidth = document.getElementById("smallRect").offsetWidth;
      const tdHeight = document.getElementById("smallRect").offsetHeight;
      for (let i = 0; i < len; i++) {
        let numb = Number(this.lotteryNumbHead[Coordinate[i].indexOf("A")]);
        let index = this.lotteryNumbHead.indexOf(numb);
        let x = leftCountWidth + 5 + (tdWidth * index + ( tdWidth / 2));
        let y = topCountWidth + (tdHeight * i + (tdHeight / 2));
        chartCoordinate.push([x, y]);
      }
      return chartCoordinate;
    },
  }
}
</script>

<style>

</style>